import { DEFAULT_TEXT_AREA_ROWS } from '../constants';

import type { TextFieldProps } from '@mui/material';


type MultilineSizingProps = Pick<TextFieldProps, 'minRows' | 'maxRows' | 'rows'>;

export function getMultilineSizingProps(
  rowsProp: TextFieldProps['rows'],
  minRows: TextFieldProps['minRows'],
  maxRows: TextFieldProps['maxRows'],
): MultilineSizingProps {
  const usesAutosizeHints = minRows != null || maxRows != null;
  if (usesAutosizeHints) {
    return {
      minRows,
      maxRows,
      rows: rowsProp,
    };
  }
  return {
    rows: rowsProp ?? DEFAULT_TEXT_AREA_ROWS,
  };
}
